import React, { Suspense, lazy, useEffect, useState, useLayoutEffect, useRef } from 'react';
const LoginComp = lazy(() => import('@components/loginComp'));
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from '@components/common/Loader/newLoaderModal';
import { login, setInActivityStatus, setScreenSaverStatus, setRelaunchTimestamp } from '@reducers/oauth';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { toggleTheme } from '@reducers/theme';
import { getMenu, removeSeat, clearCart, updatePortraitLayout } from '@reducers/orders';
import { removeStoreNotification, acknowledge } from '@reducers/storeNotifications';
import EventEmitter from '@utility/eventSubscribers';
import ensureCardReaderConnection from '@utility/ensureCardReaderConnection';
import { getObjectValue, getFormatedPhoneNumber, safeJsonParse } from '@utility/helperFunction';
import { isEmpty } from 'lodash';
import { APP_CONFIG } from '@constants';
import { flowType } from '../../utility/userInfo';
import DATA from './notificationType';
import { CUSTOM_MESSAGES } from '../../veriables';
import { paymentOrientationUpadate } from "@reducers/payment";
import { LABEL } from '../../veriables';
import { useLocation } from 'react-router';

const LoginCont = (props) => {

  // Props Destructuring

  const {toggleTheme, removeStoreNotification, removeSeat, clearCart, setScreenSaverStatus, auth, getMenu, login, 
   onCallBack, setErrorPopUp, deviceInfo, notificationTableData, acknowledge, nativeAppVersion, handleActivateRoute, serverAppTheme, orderingPortraitOrientation} = props;

  // State Management

  const [isSwipe, setIsSwipe] = useState(false);
  const [cardReaderConnectionState, setCardReaderConnectionState] = useState({
    isLoading: false,
    message: '',
  });
  const isKiosk = flowType() === 'kiosk';
  const isServerApp = flowType() === 'serverApp';
  const isCallCenter = props?.deviceInfo?.deviceGroup?.startMode === 2;
  const getTheme = safeJsonParse(window.sessionStorage.getItem('auth'), {})?.serverAppTheme;
  const location = useLocation();
  // React Hooks

  useLayoutEffect(() => {
    toggleTheme(getTheme);
    props?.updatePortraitLayout();
    props?.paymentOrientationUpadate();
  },[]);

  useLayoutEffect(() => {
    if (window.ReactNativeWebView) {
        if (orderingPortraitOrientation) {
          EventEmitter.changeOrientation({
            orientation: "portrait"
          })
        } else {
          EventEmitter.changeOrientation({
            orientation: "landscape"
          })
        }
    }
  }, [orderingPortraitOrientation])

  useEffect(() => {
    if (window.sessionStorage.getItem('launchFromExternalDevice')) {
      let value = safeJsonParse(window.sessionStorage.getItem('launchFromExternalDevice'), {});
      if (value.empId) {
        handleLaunchFromExternalApp(value.empId);
      }
    }
  }, [])

  const inactivityTimerRef = useRef(null);
  const listenersAttachedRef = useRef(false);
  const loginInFlightRef = useRef(false);

  const INACTIVITY_DELAY = 60 * 1000;
  const ACTIVITY_EVENTS = [
    'click',
    'dblclick',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'keydown'
  ];

  const detachActivityListeners = () => {
    ACTIVITY_EVENTS.forEach((event) =>
      window.removeEventListener(event, handleUserActivity)
    );
    listenersAttachedRef.current = false;
  };

  const handleUserActivity = () => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
      inactivityTimerRef.current = null;
    }
    // stopping user activity tracking after first interaction;
    detachActivityListeners();
  };

  /**
   * Tracking user interaction with the login screen
   * eg: touch interactions;
   */
  const attachActivityListeners = () => {
    if (listenersAttachedRef.current) return;

    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, handleUserActivity, { passive: true })
    );
    listenersAttachedRef.current = true;
  };

  /**
   * Responsible for updating the relaunchTimeStamp to future time
   * after app relaunches.
   */
  const setRelaunchTimestamp = () => {
    const futureTime = Date.now() + auth?.relaunchInterval * 60 * 1000;
    props.setRelaunchTimestamp(futureTime);
  };

  /**
   * Will Relaunch app after 60s when no user activity on login screen;
   */
  const startInactivityTimer = () => {
    inactivityTimerRef.current = setTimeout(() => {
      setRelaunchTimestamp();
      if (window.ReactNativeWebView){
         EventEmitter.reLaunchApp();
      }
    }, INACTIVITY_DELAY);
  };

  useEffect(() => {
    const isLoggedInOnce = safeJsonParse(
      window.sessionStorage.getItem('isLoggedInOnce'),
      false
    );
    const savedTimestamp = props.relaunchTimestamp;
    const queryParams = new URLSearchParams(location.search);
    const logoutTimeStr = queryParams.get('logoutAfterRelaunchInterval');
    attachActivityListeners();

    if (
      // check if reluanch is enabled;
      auth?.relaunchEnabled &&
      // check if currently in login screen;
      window.location.pathname === '/checkIn' &&
      // check if user has logged in atleast once;
      isLoggedInOnce &&
      logoutTimeStr?.length > 0
    ) {
      const logoutTime = logoutTimeStr && Number(logoutTimeStr);
      const relaunchTime = savedTimestamp ? Number(savedTimestamp) : null;
      
      // compare logout time with timeSpent;
      // relaunchTime must exist; null means no interval has been set yet
      if (relaunchTime !== null && logoutTime > relaunchTime) {
        // if logoutTime > timeSpent -> Relaunch after 60 seconds
        startInactivityTimer();
      }
    }

    // cleanup
    return () => {
      detachActivityListeners();
      clearTimeout(inactivityTimerRef.current);
    };
  }, []);

  const removeNotification = (id) => {
    removeStoreNotification(id);
  };

  useEffect(() => {
    removeSeat();
    clearCart();
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(true);
    }
    setScreenSaverStatus(isServerApp);
    try {
      EventEmitter.activateIngenicoDevice(() => {
        console.log('ingenice success');
      });
      EventEmitter.sendMessage({ type: 'initializeIngenico', data: { ...auth } }, () => {
      },
      () => {
        console.log('failure');
      });
    } catch (e) {
      console.log(e);
    }
  }, []);

  // Methods

  const menuApi = () => {
    switch (flowType()) {
      default: getMenu(safeJsonParse(window.sessionStorage.getItem('auth'), {})?.id , isCallCenter, undefined, true); break;
    }
  };

  const showErrorPopupAndWaitForDismiss = (popupConfig) => {
    return new Promise((resolve) => {
      setErrorPopUp({
        ...popupConfig,
        onClickChange: (...args) => {
          if (typeof popupConfig.onClickChange === 'function') {
            popupConfig.onClickChange(...args);
          }

          resolve();
        }
      });
    });
  };

  const ensureLoginCardReaderConnection = async () => {
    setCardReaderConnectionState({
      isLoading: true,
      message: LABEL().CARD_READER_CHECKING_CONNECTION,
    });

    try {
      return await ensureCardReaderConnection({
        maxReconnectAttempts: 2,
        skipConnectionCheck: Boolean(props.deviceInfo?.deviceGroup?.serverAppSettings?.disablePayment) || props.deviceInfo?.deviceGroup?.paymentTypes?.creditCard === false,
        onProgress: (message) => {
          console.log('ensureCardReaderConnection - onProgress:', message);
          setCardReaderConnectionState({
            isLoading: true,
            message,
          });
        },
      });
    } finally {
      setCardReaderConnectionState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  const completeSuccessfulLogin = () => {
    window.sessionStorage.setItem('isLoggedInOnce', true);
    onCallBack();
    menuApi();
  };

  const signIn = async (loginData) => {
    if (loginInFlightRef.current) {
      return;
    }

    loginInFlightRef.current = true;
    setIsSwipe(false);

    try {
      const loginPromise = Promise.resolve(login(loginData))
        .then((result) => ({ ok: true, result }))
        .catch((error) => ({ ok: false, error }));
      const cardReaderPromise = ensureLoginCardReaderConnection();
      const cardReaderResult = await cardReaderPromise;
      const loginResult = await loginPromise;

      if (cardReaderResult.ok) {
        console.log('ensureCardReaderConnection - succeeded:', cardReaderResult.message || cardReaderResult);
      } else {
        const error = cardReaderResult.error;
        const errorMessage =
          error?.message ||
          'Card reader is not ready. Please check the connection and try again.';

        console.error('ensureCardReaderConnection - failed: ' + errorMessage, error);
      }

      if (!loginResult.ok) {
        throw loginResult.error;
      }

      if (!cardReaderResult.ok) {
        await showErrorPopupAndWaitForDismiss({
          res: LABEL().LOGIN_CARD_READER_WARNING,
          buttonLabel: LABEL().CONTINUE_TO_ORDERING,
          fullWidth: true,
        });
      }

      completeSuccessfulLogin();
    } catch (err) {
      setErrorPopUp({
        res: err?.message || 'Login failed. Please try again.'
      });
    } finally {
      setCardReaderConnectionState({
        isLoading: false,
        message: '',
      });
      loginInFlightRef.current = false;
    }
  };

  const handleLaunchFromExternalApp = (empId) => {
    const data = {
      employeeId: empId,
      latitude: '92',
      longitude: '92',
      deviceId: deviceInfo.deviceId,
    };
    signIn(data);
  }

  function toHoursAndMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return { hours, minutes };
  }

  let getRelaunchTime = (storedTime, hoursMinutes) => {
    let hours = Number(storedTime[0]) + hoursMinutes.hours;
    let value = toHoursAndMinutes(Number(storedTime[1]) + hoursMinutes.minutes)
    let minutes;
    if (value.hours > 0) {
      hours = hours + value.hours;
      minutes = value.minutes
    } else {
      minutes = value.minutes
    }
    return { hours, minutes }
  }

  const handleStopMagneticRead = () => {
    EventEmitter.stopMagneticCardRead();
    EventEmitter.sendMessage({ type: 'stopMagCard' }, () => {
      console.log('success');
    },
    () => {
      console.log('failure');
    });
    setIsSwipe(false);
  };

  let notificationTypes = DATA.notificationTypes;

  if (getObjectValue(() => deviceInfo.deviceGroup.notificationTypeFilters, false)) {
    notificationTypes = notificationTypes.map((e) => {
      return {
        ...e,
        status: getObjectValue(() => deviceInfo.deviceGroup.notificationTypeFilters[e.shortName], false)
      };
    });
  }

  let filteredNotifications = [];
  if (getObjectValue(() => deviceInfo.deviceGroup.notificationTypeFilters, false)) {
    filteredNotifications = notificationTableData.filter((e) => e.enabled && notificationTypes.some((d) => (e.notificationTypeId === d.id) && d.status));
  } else {
    filteredNotifications = notificationTableData;
  }
  const onLoginClick = (data, empCard) => {
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      deviceId: deviceInfo.deviceId,
      employeeCode: data.loginKeyboard,
      employeeCard: empCard || null
    };
    signIn(dataToSend);
  };

  const initializeIngenico = () => {
    try {
      EventEmitter.scanIngenicoDevice((res) => {
        onLoginClick({}, res);
      },
      () => {
        handleStopMagneticRead();
      });
      EventEmitter.sendMessage({ type: 'scanMagCard' }, () => {
        console.log('success');
        window.sessionStorage.setItem('isLoggedInOnce', true);
      },
      () => {
        console.log('failure');
      });
    } catch (e) {
      console.log('catch', e);
    }
  };

  const acknowledged = (id) => {
    const dataToSend = {
      storeId: deviceInfo.storeId,
      notificationId: id
    };
    acknowledge(dataToSend).then(() => {
      removeStoreNotification(id);
    });
  };

  const validateLogin = (data) => {
    return new Promise((resolve, reject) => {
      const error = {};
      if (!data.loginKeyboard) {
        error.login ='';
         props.setErrorPopUp({
                  res: CUSTOM_MESSAGES().EMPLOYEE_CODE_IS_REQUIRED,
                  noErrorTxt: true,
                });
      }
      if (isEmpty(error)) {
        resolve();
      } else {
        reject(new Error(error.login));
      }
    });
  };

  // HTML CSS Code

  return (
    <>
      {(props.loading || cardReaderConnectionState.isLoading) && <Loader message={cardReaderConnectionState.message} />}
      <Suspense fallback={props.loading && <Loader />}>
      <LoginComp
        notificationTableData={filteredNotifications}
        isKiosk={isKiosk}
        acknowledge={acknowledged}
        removeStoreNotification={removeNotification}
        initializeIngenico={initializeIngenico}
        onLoginClick={onLoginClick}
        version={APP_CONFIG.VERSION}
        desktopImage={getObjectValue(() => JSON.parse(window.sessionStorage.themeProperties).serverAppHeroImageUrl, '')}
        storeName={getObjectValue(() => auth.name, '')}
        deviceName={getObjectValue(() => deviceInfo.deviceName, '')}
        nativeAppVersion={nativeAppVersion}
        validateLogin={validateLogin}
        storePhoneNumber={getObjectValue(() => getFormatedPhoneNumber(auth.supportPhoneNumber), '')}
        handleActivateRoute={handleActivateRoute}
        setIsSwipe={setIsSwipe}
        isSwipe={isSwipe}
        handleStopMagneticRead={handleStopMagneticRead}
        auth = {auth}
        serverAppTheme={serverAppTheme}
        isOrderingPortrait={orderingPortraitOrientation}
        />
        </Suspense>
    </>
  );
};

// Redux part

const mapDispatchToProps = (dispatch) => bindActionCreators({
  login,
  getMenu,
  acknowledge,
  setNotification,
  setErrorPopUp,
  removeStoreNotification,
  removeSeat,
  setInActivityStatus,
  clearCart,
  setScreenSaverStatus,
  toggleTheme,
  updatePortraitLayout,
  paymentOrientationUpadate,
  setRelaunchTimestamp
}, dispatch);

const mapStateToProps = ({ oauth, storeNotifications, theme, orders}) => ({
  loading: oauth.loading,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  notificationTableData: storeNotifications.storeNotification,
  nativeAppVersion: oauth.nativeAppVersion,
  deviceTypeId: oauth.deviceTypeId,
  themeProperties: theme.themeProperties,
  serverAppTheme: theme.serverAppTheme,
  orderingPortraitOrientation: orders.orderingPortraitOrientation,
  relaunchTimestamp: oauth.relaunchTimestamp,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginCont);
